import { useWindowSize } from '@/hooks/useWindowSize'
import { useMemo } from 'react'

export const useDrawerWidth = (): number => {
    const { width } = useWindowSize()
    return useMemo((): number => Math.min(264, width * 0.75), [width])
}
